<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>کانتورینگ   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5" >
                <template #default>کانتورینگ صورت صورت یک عمل زیبایی است که کانتور مورد نظر را در نواحی مختلف صورت ایجاد می کند. این یک درمان محبوب است که می تواند به شما کمک کند ظاهری جوان تر و مشخص تر داشته باشید. این روش شامل استفاده از پرکننده ها یا ایمپلنت ها برای تقویت فرم صورت و ایجاد ظاهری متعادل تر است.
   </template>
                </m-h4><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/1.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/2.jpg","direction":"horizontal","beforeText":"\u0642\u0628\u0644","afterText":"\u0628\u0639\u062f"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mSection200 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mSection200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
